module.exports = __webpack_public_path__ + "static/media/08-lab2.569f8bed.png";